import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** CLOUDWEB-19916: Новое апи для списка продуктов - айфрейм /buy в вебвью */
export const newProductsApiInBuyWebview: boolean = isFeature('new-products-api-buy-webview');
